// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o6-1";
export var messageSideRight = "_o6-2";
export var subscribeToBackInStockBubbleContainer = "_o6-0";